// ------ Vendor packages 
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Tooltip from 'vue-directive-tooltip';
import * as Cookies from "js-cookie";
import VueClipboard from 'vue-clipboard2';
import Sticky from 'vue-sticky-directive';
import Datepicker from 'vuejs-datepicker';
import Chart from 'chart.js/auto';
import Ads from 'vue-google-adsense';

const DonateAmountInput = () => import(
    /* webpackChunkName: "donate" */
    './Donate/DonateAmountInput.vue'
);

// ---------- Player Dashboard
const PlayerDashboard = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerDashboard.vue'
);
const PlayerBotOpponents = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerBotOpponents.vue'
);
const PlayerDailyProgressGraph = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerDailyProgressGraph.vue'
);
const PlayerRecentKillChart = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerRecentKillChart.vue'
);
const PlayerOpponentsList = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Player/PlayerOpponentsList.vue'
);
const PlayerRecentMatchAverages = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerRecentMatchAverages.vue'
);
const PlayerRecentMatchList = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerRecentMatchList.vue'
);
const PlayerRecentMatchMaps = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Dashboard/PlayerRecentMatchMaps.vue'
);
const RecentTeammates = () => import(
    /* webpackChunkName: "player-dashboard" */
    './Users/RecentTeammates.vue'
);
const PubgReportSearch = () => import(
    /* webpackChunkName: "player-dashboard" */
    './PubgReport/Search.vue'
);


// Weapon Mastery
const PlayerWeaponMastery = () => import(
    /* webpackChunkName: "weapon-mastery" */
    './WeaponMastery/PlayerWeaponMastery.vue'
);

// Player

const ArcadeModeDetails = () => import(
    /* webpackChunkName: "match-report-01" */
    './EventMode/ArcadeModeDetails.vue'
);
const EventModeDetails = () => import(
    /* webpackChunkName: "match-report-01" */
    './EventMode/EventModeDetails.vue'
);
const MatchDetails = () => import(
    /* webpackChunkName: "match-report-01" */
    './Match/MatchDetails.vue'
);
const MatchPanelPreview = () => import(
    /* webpackChunkName: "match-report-01" */
    './Match/MatchPanelPreview.vue'
);
const MatchKillTree = () => import(
    /* webpackChunkName: "match-report-01" */
    './Match/MatchKillTree.vue'
);
const DamageType = () => import(
    /* webpackChunkName: "match-report-01" */
    './Match/DamageType.vue'
);
const GameModeIcon = () => import(
    /* webpackChunkName: "match-report-01" */
    './Match/GameModeIcon.vue'
);
const PubgReportFindMatch = () => import(
    /* webpackChunkName: "match-report-01" */
    './PubgReport/FindMatch.vue'
);

// ---------- Player Stats
const MatchesCarousel = () => import(
    /* webpackChunkName: "player-stats" */
    './Match/MatchesCarousel.vue'
);
const PlayerPanel = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/PlayerPanel.vue'
);
const PlayerProfileDropdown = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/PlayerProfileDropdown.vue'
);
const PlayerSeasonStats = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/PlayerSeasonStats.vue'
);
const PlayerRankedSeasonStats = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/PlayerRankedSeasonStats.vue'
);
const PlayerRankPreview = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/PlayerRankPreview.vue'
);
const RankIcon = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/RankIcon.vue'
);
const ShareMatch = () => import(
    /* webpackChunkName: "player-stats" */
    './Match/ShareMatch.vue'
);
const RecentMatchStats = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/RecentMatchStats.vue'
);
const SelectPlayerRegion = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/SelectPlayerRegion.vue'
);
const WeaponsStats = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/WeaponsStats.vue'
);
const LifetimeStats = () => import(
    /* webpackChunkName: "player-stats" */
    './Player/LifetimeStats.vue'
);

// --------- Scoreboards
const ScoreboardPanel = () => import(
    /* webpackChunkName: "scoreboards" */
    './Scoreboards/ScoreboardPanel.vue'
);
const ScoreboardPanelPreview = () => import(
    /* webpackChunkName: "scoreboards" */
    './Scoreboards/ScoreboardPanelPreview.vue'
);
const ScoreboardAddProfiles = () => import(
    /* webpackChunkName: "scoreboards" */
    './Scoreboards/ScoreboardAddProfiles.vue'
);

// ---------- BINGO
const BingoCard = () => import(
    /* webpackChunkName: "bingo" */
    './Bingo/BingoCard.vue'
);


// ---------- Tournaments
const TournamentSlugInput = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentSlugInput.vue'
);
const TournamentPlacementPoints = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentPlacementPoints.vue'
);
const TournamentPlatformSelection = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentPlatformSelection.vue'
);
const TournamentPlayersPerTeamSelection = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentPlayersPerTeamSelection.vue'
);
const TournamentStreamProfileInput = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentStreamProfileInput.vue'
);
const TournamentStreamEmbed = () => import(
    /* webpackChunkName: 'tournaments-management' */
    './Tournaments/TournamentStreamEmbed.vue'
);

// ------------ League & Leaderboards
const LeaderboardPlayerSearch = () => import(
    /* webpackChunkName: 'leaderboards' */
    './League/LeaderboardPlayerSearch.vue'
);

// ------------ Player Search
const ProfileSearchInput = () => import(
    /* webpackChunkName: 'player-search' */
    './Search/ProfileSearchInput.vue'
);
const PlayerSearch = () => import(
    /* webpackChunkName: 'player-search' */
    './Search/PlayerSearch.vue'
);
const PlayerSearchMini = () => import(
    /* webpackChunkName: 'player-search' */
    './Search/PlayerSearchMini.vue'
);
const PlayerCompareSearch = () => import(
    /* webpackChunkName: 'player-search' */
    './Search/PlayerCompareSearch.vue'
);
const MatchRosterSearch = () => import(
    /* webpackChunkName: 'player-search' */
    './Search/MatchRosterSearch.vue'
);

// --------- UI 
const CopyToClipboardButton = () => import(
    /* webpackChunkName: 'ui-components' */
    './Season/CopyToClipboardButton.vue'
);
const FavoriteButton = () => import(
    /* webpackChunkName: 'ui-components' */
    './Users/FavoriteButton.vue'
);
const FavoritesList = () => import(
    /* webpackChunkName: 'ui-components' */
    './Users/FavoritesList.vue'
);
const FavoritePanel = () => import(
    /* webpackChunkName: 'ui-components' */
    './Users/FavoritePanel.vue'
);
const FriendButton = () => import(
    /* webpackChunkName: 'ui-components' */
    './Users/FriendButton.vue'
);
const FriendsList = () => import(
    /* webpackChunkName: 'ui-components' */
    './Users/FriendsList.vue'
);
const Loader = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/Loader.vue'
);
const LoaderGhostTable = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/LoaderGhostTable.vue'
);
const Panel = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/Panel.vue'
);
const PlatformIcon = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/PlatformIcon.vue'
);
const ProgressBar = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/ProgressBar.vue'
);
const PubgRegionSelector = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/PubgRegionSelector.vue'
);
const RibbonItemDelta = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/RibbonItemDelta.vue'
);
const SeasonSelector = () => import(
    /* webpackChunkName: 'ui-components' */
    './Season/SeasonSelector.vue'
);
const StreamOverlayUrlInput = () => import(
    /* webpackChunkName: 'ui-components' */
    './Account/StreamOverlayUrlInput.vue'
);
const TableCellDelta = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/TableCellDelta.vue'
);
const VerifiedIcon = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/VerifiedIcon.vue'
);
const WeatherIcon = () => import(
    /* webpackChunkName: 'ui-components' */
    './Components/WeatherIcon.vue'
);


// -------- UI Notices
const CookiesNotice = () => import(
    /* webpackChunkName: 'ui-notices' */
    './Account/CookiesNotice.vue'
);
const AdSupportNotice = () => import(
    /* webpackChunkName: 'ui-account' */
    './Account/AdSupportNotice.vue'
);
const SaveToHomeScreen = () => import(
    /* webpackChunkName: 'ui-notices' */
    './Account/SaveToHomeScreen.vue'
);
const AnnouncementBanner = () => import(
    /* webpackChunkName: 'ui-notices' */
    './Account/AnnouncementBanner.vue'
);
const LinkAccountBanner = () => import(
    /* webpackChunkName: 'ui-notices' */
    './Account/LinkAccountBanner.vue'
);


// --------- UNUSED COMPONENTS - Feb 2022

// const MatchMaps = () => import(
//     /* webpackChunkName: "player-stats" */
//     './Player/MatchMaps.vue'
// );

// const ConsoleMatchMaps = () => import(
//     /* webpackChunkName: "match-analytics" */
//     './Analytics/ConsoleMatchMaps.vue'
// );

// const ConsoleGameModeChart = () => import(
//     /* webpackChunkName: "match-analytics" */
//     './Analytics/ConsoleGameModeChart.vue'
// );

// const ConsoleKillAnalytics = () => import(
//     /* webpackChunkName: "match-analytics" */
//     './Analytics/ConsoleKillAnalytics.vue'
// );

// const HotDropChart = () => import(
//     /* webpackChunkName: "match-analytics" */
//     './Analytics/HotDropChart.vue'
// );

// const MatchHighlightPanel = () => import(
//     /* webpackChunkName: 'ui-components' */
//     './MatchHighlight/MatchHighlightPanel.vue'
// );


// Globals
window.Vue = Vue;
window.Vuex = Vuex;
window.Cookies = Cookies;
window.axios = axios;
window.Chart = Chart;
window.axios.defaults.baseURL = '/api/';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

Vue.use(Vuex);
Vue.use(Tooltip, {
    triggers: ['hover']
});
Vue.use(VueClipboard);
Vue.use(Sticky);

// Ads & Adsense
Vue.use(require('vue-script2'));
Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);

// Unused components - Feb 2022
// Vue.component('match-maps', MatchMaps);
// Vue.component('console-match-maps', ConsoleMatchMaps);
// Vue.component('console-game-mode-chart', ConsoleGameModeChart);
// Vue.component('console-kill-analytics', ConsoleKillAnalytics);
// Vue.component('hot-drop-chart', HotDropChart);
// Vue.component('match-highlight-panel', MatchHighlightPanel);


// Vue.component('datetime', Datetime);
Vue.component('datepicker', Datepicker);
Vue.component('loader', Loader);
Vue.component('loader-ghost-table', LoaderGhostTable);
Vue.component('panel', Panel);
Vue.component('weather-icon', WeatherIcon);
Vue.component('platform-icon', PlatformIcon);
Vue.component('verified-icon', VerifiedIcon);
Vue.component('donate-amount-input', DonateAmountInput);

Vue.component('bingo-card', BingoCard);

// Vue.component('editor', Editor);

// Vue.component('console-match-maps', ConsoleMatchMaps);
// Vue.component('console-game-mode-chart', ConsoleGameModeChart);
// Vue.component('console-kill-analytics', ConsoleKillAnalytics);
// Vue.component('hot-drop-chart', HotDropChart);

Vue.component('player-dashboard', PlayerDashboard);
Vue.component('player-recent-match-averages', PlayerRecentMatchAverages);
Vue.component('player-recent-match-list', PlayerRecentMatchList);
Vue.component('player-bot-opponents', PlayerBotOpponents);
Vue.component('player-recent-match-maps', PlayerRecentMatchMaps);
Vue.component('player-daily-progress-graph', PlayerDailyProgressGraph);
Vue.component('player-recent-kill-chart', PlayerRecentKillChart);
Vue.component('player-opponents-list', PlayerOpponentsList);

Vue.component('progress-bar', ProgressBar);
Vue.component('game-mode-icon', GameModeIcon);
Vue.component('rank-icon', RankIcon);
Vue.component('ribbon-item-delta', RibbonItemDelta);

Vue.component('event-mode-details', EventModeDetails);
Vue.component('arcade-mode-details', ArcadeModeDetails);

Vue.component('match-details', MatchDetails);
Vue.component('matches-carousel', MatchesCarousel);
Vue.component('match-panel-preview', MatchPanelPreview);
// Vue.component('match-console-stats', MatchConsoleStats);
// Vue.component('match-damage-stats', MatchDamageStats);
// Vue.component('match-bot-interactions', MatchBotInteractions);
Vue.component('match-kill-tree', MatchKillTree);
// Vue.component('match-map', MatchMap);
// Vue.component('match-medic-details', MatchMedicDetails);
// Vue.component('match-phase-kills', MatchPhaseKills);
// Vue.component('player-team', PlayerTeam);
// Vue.component('player-kills', PlayerKills);
// Vue.component('player-death', PlayerDeath);
// Vue.component('player-match-stats-overview', PlayerMatchStatsOverview);
// Vue.component('arcade-mode-stats-overview', ArcadeModeStatsOverview);
// Vue.component('leaderboard-list', LeaderboardList);
Vue.component('table-cell-delta', TableCellDelta);
Vue.component('damage-type', DamageType);
Vue.component('pubg-region-selector', PubgRegionSelector);
Vue.component('player-rank-preview', PlayerRankPreview);
Vue.component('lifetime-stats', LifetimeStats);
Vue.component('recent-match-stats', RecentMatchStats);
Vue.component('share-match', ShareMatch);

Vue.component('player-season-stats', PlayerSeasonStats);
Vue.component('player-ranked-season-stats', PlayerRankedSeasonStats);

Vue.component('weapons-stats', WeaponsStats);

Vue.component('player-weapon-mastery', PlayerWeaponMastery);

Vue.component('leaderboard-player-search', LeaderboardPlayerSearch);

Vue.component('player-profile-dropdown', PlayerProfileDropdown);
Vue.component('profile-search-input', ProfileSearchInput);
Vue.component('player-search', PlayerSearch);
Vue.component('player-search-mini', PlayerSearchMini);
Vue.component('player-compare-search', PlayerCompareSearch);
Vue.component('match-roster-search', MatchRosterSearch);

Vue.component('select-player-region', SelectPlayerRegion);
Vue.component('stream-overlay-url-input', StreamOverlayUrlInput);
Vue.component('link-account-banner', LinkAccountBanner);
Vue.component('save-to-home-screen', SaveToHomeScreen);
Vue.component('cookies-notice', CookiesNotice);
Vue.component('ad-support-notice', AdSupportNotice);
Vue.component('announcement-banner', AnnouncementBanner);

Vue.component('player-panel', PlayerPanel);

Vue.component('scoreboard-panel', ScoreboardPanel);
Vue.component('scoreboard-panel-preview', ScoreboardPanelPreview);
Vue.component('scoreboard-add-profiles', ScoreboardAddProfiles);

Vue.component('tournament-slug-input', TournamentSlugInput);
Vue.component('tournament-placement-points', TournamentPlacementPoints);
Vue.component('tournament-platform-selection', TournamentPlatformSelection);
Vue.component('tournament-players-per-team-selection', TournamentPlayersPerTeamSelection);
Vue.component('tournament-stream-profile-input', TournamentStreamProfileInput);
Vue.component('tournament-stream-embed', TournamentStreamEmbed);

Vue.component('pubg-report-search', PubgReportSearch);
Vue.component('pubg-report-find-match', PubgReportFindMatch);

Vue.component('favorite-button', FavoriteButton);
Vue.component('favorites-list', FavoritesList);
Vue.component('favorite-panel', FavoritePanel);
Vue.component('friend-button', FriendButton);
Vue.component('friends-list', FriendsList);
Vue.component('recent-teammates', RecentTeammates);

Vue.component('season-selector', SeasonSelector);
Vue.component('copy-to-clipboard', CopyToClipboardButton);

Vue.filter("formatNumber", (value) => {
    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
});
Vue.filter("formatNumberDecimal", (value) => {
    return value.toLocaleString(undefined, { minimumFractionDigits: 2 });
});
Vue.filter("secondsToTime", (seconds) => {
    let minutes, hours, returnStr;
    minutes = Math.floor(seconds / 60);
    hours = Math.floor(minutes / 60) % 60;

    let secondsConverted = seconds%60;

    minutes = minutes%60;

    returnStr = ("0"+minutes).slice(-2)+":"+("0"+Math.floor(secondsConverted)).slice(-2);

    return hours ? ("0"+hours).slice(-2)+":"+returnStr : returnStr;
});
Vue.filter('truncate', (text, stop, clamp) => {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
});
